import dayjs, { Dayjs } from "dayjs";

/**
 * Parsea una hora "HH:mm" o "HH:mm:ss" a Dayjs sin depender de customParseFormat.
 * Así el TimePicker siempre recibe un Dayjs válido tras refrescar la página.
 */
export const toDayjsHour = (t: string | null): Dayjs | null => {
  if (!t || typeof t !== "string") return null;
  const trimmed = t.trim().slice(0, 5);
  const [h, m] = trimmed.split(":").map((s) => parseInt(s, 10));
  if (Number.isNaN(h) || Number.isNaN(m)) return null;
  return dayjs().hour(h).minute(m).second(0).millisecond(0);
};

/** Hora 00:00 como Dayjs válido para valores por defecto del TimePicker. */
export const defaultTimeDayjs = (): Dayjs =>
  dayjs().hour(0).minute(0).second(0).millisecond(0);
